import { useState, useRef, useEffect } from 'react';
import Search from '../../assets/search.png';
import Searchbar from '../../components/Search';
import Dropdown from '../../assets/dropdown.png';
import Eye from '../../assets/eye.png'
import Delete from '../../assets/trash.png'
import Delete1 from '../../assets/trash123.png'
import Cookies from 'js-cookie'
import useApiPost from '../hooks/postData';
import useApiGet from '../hooks/getData';
import formatDate from '../../components/formatDate';
import formatTime from '../../components/formatTime';
import { Link } from 'react-router-dom';
import Arrow from '../../assets/Showing_Arrow.png'
import ReelDetail from './ReelDetail';
import DeleteReel from './DeleteReel';
import DeactiveArrow from '../../assets/deactive_Arrow.png'
import Loader from '../../assets/Loader.gif'
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
import NoData from '../../assets/NoData.png'
import { useGetMotionpixQuery } from '../../store/api/AllPostsReels';
import { useDebounce } from '../../utils/hooks/debounce';

function ReelList() {
  // Sample data for posts
  const [activePage, setActivePage] = useState(1)
  const token = Cookies.get("Snapta_Admin_Token")
  const [selectedPostId, setSelectedPostId] = useState(null)
  const [order, setOrder] = useState("");
  const [category, setCategory] = useState("");
  const [isLoading, setIsLoading] = useState(false)
  const [search, setSearch] = useState("")
  const navigate = useNavigate()
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState("10");
  const dropdownRef = useRef(null);

  // Options for dropdown
  const options = ["10", "25", "50", "100"]

  // Function to handle option selection
  const handleSelect = (value) => {
    setSelectedValue(value);
    setIsDropdownOpen(false);
    setActivePage(1)
  };

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);




  const debouncedSearch = useDebounce(search);
  useEffect(() => {
    setActivePage(1);
  }, [debouncedSearch])
  const { data: motionpixResponse, isFetching, refetch } = useGetMotionpixQuery({
    limit: selectedValue,
    page: selectedValue != 10 ? 1 : activePage,
    search: debouncedSearch,
  })


  const pagination = motionpixResponse?.data?.pagination;
  const lastPage = pagination?.last_page || 1;
  const currentPage = pagination?.current_page
  const AllReelList = motionpixResponse?.data?.posts || [];

  // To open reel detail dialog box 
  const [openDetail, setOpenDetail] = useState(false)
  const handleReelDetailOpen = (postId) => {
    setOpenDetail(true)
    setSelectedPostId(postId);
  };
  const handleReelDetailClose = () => {
    setOpenDetail(false)
    setSelectedPostId(null)
  }
  const [open, setOpen] = useState(false)
  const handleOpen = (ReelId) => {
    setOpen(true)
    setSelectedPostId(ReelId)
  }
  const handleClose = () => {
    setOpen(false)
  }

  const handleDelete = async () => {
    refetch();
    // await handleGetReelList(false); // Refetch post list
  };



  // To open User Profile 
  const [userId, setUserId] = useState("")
  const location = useLocation()
  const handleOpenUserProfile = (userId) => {
    const currentPath = location.pathname.split("/")[1]; // gets 'reel-list', 'user-list', etc.
    setUserId(userId);
    Cookies.set("userId", userId);
    navigate(`/${currentPath}/user-profile`);
  };
  const isSidebarOpen = useSelector((state) => state.sidebar.isOpen);


  return (
    <>
      <div className={`light:mb-10 dark:bg-primary ${isSidebarOpen ? "xl:pl-20" : "xl:pl-72"}`}>

        <Searchbar />

        <div className='px-4 pb-10 xl:px-6'>
          {/* Title */}
          <div className="flex justify-between border-t-[#F2F2F2] pt-3">
            <h2 className="my-auto text-xl font-semibold dark:text-darkText text-lightText font-poppins">Motionpix List</h2>
            <div className="relative">
              <div className="absolute flex items-center transform -translate-y-1/2 left-2 top-1/2">
                <img src={Search} alt="Search" className="w-5 h-  5" />
              </div>
              <input
                type="text"
                className="border border-gray-500 w-[160px] xl:placeholder:text-sm dark:text-white placeholder:dark:text-tableDarkLarge bg-[#00000005] md:w-[250px] border-opacity-10 rounded-lg py-2 pl-10 placeholder:text-xs placeholder:text-[#0000004F] focus:outline-none focus:ring-1 focus:ring-gray-600"
                placeholder="Search by stagename..."
                onChange={(e) => (setActivePage(1), setSearch(e.target.value))}
                value={search}
              />
            </div>
          </div>

          {/* Navigation Path */}
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center gap-2">
              <Link to="/dashboard"><h3 className="text-base font-semibold dark:text-darkText text-lightText font-poppins">Dashboard</h3></Link>
              <div className="rounded-full w-1 h-1 bg-[#E0E0E0]"></div>
              <h3 className="text-[#858585] font-poppins text-base">Motionpix List</h3>
            </div>
          </div>

          {/* Header Bar */}
          <div className="border border-[#E3E3E3] dark:border-[#1F1F1F] rounded-lg mt-4 overflow-x-auto w-full">
            <div className='xl:overflow-x-auto lg:overflow-x-auto 2xl:overflow-hidden'>
              <div className='min-w-max'>
                {/* Table Header */}
                <div className="flex justify-between px-4 py-3 pl-1 text-left border-b dark:border-b-[#1F1F1F] bg-header1 dark:bg-darkHeader sm:pl-4">
                  {/* SL */}
                  <div className="w-[40px] text-headerText font-poppins text-sm font-semibold">S.L </div>

                  {/* Reel Image */}
                  <div className="w-[70px] text-headerText font-poppins text-sm flex items-center gap-2 font-semibold">IMAGE</div>

                  {/* Username */}
                  <div className="w-[16ch] text-headerText font-poppins text-sm flex items-center gap-2 font-semibold">
                    STAGENAME
                  </div>

                  {/* Date/Time */}
                  <div className="w-[18%] text-headerText font-poppins font-semibold text-sm flex items-center gap-2">
                    POSTED DATE/TIME
                  </div>

                  {/* Likes */}
                  <div className="w-[10%] text-headerText font-semibold font-poppins text-sm flex items-center gap-2">
                    REACTION
                  </div>

                  {/* Comments */}
                  <div className="w-[12%] text-headerText font-semibold font-poppins text-sm flex items-center gap-2">
                    COMMENTS
                  </div>

                  {/* status */}
                  <div className="w-[10%] text-headerText font-semibold font-poppins text-sm">MODE </div>

                  {/* Actions */}
                  <div className="w-[10%] text-headerText font-semibold font-poppins text-sm">ACTIONS </div>
                </div>

                {/* Data Rows */}
                {isFetching ? (<div className='flex justify-center py-60'><img src={Loader} alt="loader" height={50} width={50} /></div>) :
                  (<>

                    {AllReelList?.length > 0 ?
                      (<>
                        {AllReelList?.map((reel, index) => (
                          <div key={reel.id}
                            className={`${index % 2 === 0 ? 'bg-white dark:bg-primary' : 'bg-[#00162e0a] dark:bg-primary'} flex justify-between items-center px-4 py-3 sm:pl-4 pl-4 border-b dark:border-b-[#1F1F1F] last:border-0`}>

                            {/* Serial Number */}
                            <div className="min-w-[40px] text-[#000000] dark:text-darkText font-poppins text-sm">{(currentPage - 1) * selectedValue + index + 1}</div>

                            {/* Reel Image */}
                            <div className="w-[70px] cursor-pointer" onClick={() => handleReelDetailOpen(reel.post_id)}>
                              <img src={reel?.thumbnail} className="object-cover rounded-lg w-14 h-14" />
                            </div>

                            {/* Username */}
                            <div className="w-[16ch] flex gap-2 items-center">
                              {/* <img src={reel.profile_pic} className="w-12 h-12 rounded-full" /> */}
                              <div>
                                <h2 className="text-[#00162e] dark:text-darkText font-poppins text-sm font-semibold cursor-pointer" onClick={() => handleOpenUserProfile(reel.user_id)}>{reel.username}</h2>
                                <p className="text-xs dark:text-tableDarkLarge text-tableLightLarge font-poppins">{reel.stage_name}</p>
                              </div>
                            </div>

                            {/* Date and Time */}
                            <div className="w-[18%]">
                              <h2 className="text-[#414141] dark:text-darkText font-poppins text-sm">{formatDate(reel.create_date)}</h2>
                              <h2 className="text-[#7A7A7A] dark:text-tableDarkLarge font-poppins text-xs">{formatTime(reel.create_date)}</h2>
                            </div>

                            {/* Likes */}
                            <div className="w-[10%] text-[#3A3A3A] dark:text-tableDarkLarge font-poppins text-sm">{reel.total_reactions} {reel.total_reactions > 1 ? "Reactions" : "Reaction"}</div>

                            {/* Comments */}
                            <div className="w-[12%] text-[#3A3A3A] dark:text-tableDarkLarge font-poppins text-sm">{reel.total_comments} {reel.total_comments > 1 ? "Comments" : "Comment"}</div>

                            {/* Views */}
                            {/* <div className='w-[10%] text-[#3A3A3A] dark:text-tableDarkLarge font-poppins text-sm'>{reel.total_views} {reel.total_views > 1 ? "Views" : "View"}</div> */}

                            {/* Status */}
                            <div className='w-[10%] text-[#3A3A3A] dark:text-tableDarkLarge font-poppins text-sm'>{reel.mode?.toUpperCase()}</div>

                            {/* Actions */}
                            <div className="w-[10%] flex gap-4">
                              <button className="bg-[#CCE1CD] dark:bg-[#01D312] border border-[#01D312] border-opacity-[20%]   bg-opacity-[57%] dark:bg-opacity-[4%] rounded-full p-2" onClick={() => handleReelDetailOpen(reel.post_id)}>
                                <img src={Eye} className="w-4 h-4" />
                              </button>
                              <button className="bg-[#FDE4EA] dark:bg-[#FF3030] border border-[#FF3030] border-opacity-[20%]  dark:bg-opacity-[6%] rounded-full p-2" onClick={() => handleOpen(reel.id)}>
                                <img src={Delete} className='block w-4 h-4 dark:hidden' />
                                <img src={Delete1} className='hidden w-4 h-4 dark:block' />
                              </button>
                            </div>
                          </div>
                        ))}
                      </>) :
                      (<>
                        <div className='flex flex-col justify-center py-32 2xl:py-36 place-items-center'>
                          <img src={NoData} alt="no data" className='w-96' />
                          <h2 className='font-poppins text-[#000000] text-sm font-semibold'>Don't have any data to show</h2>
                        </div>
                      </>)}

                  </>)}




                {/* Pagination and Results Count */}
                {AllReelList?.length > 0 ? (<>
                  <div className="flex justify-between px-10 py-6 bg-white dark:bg-primary">

                    {/* Results Count */}
                    <div className="relative flex gap-2 place-items-center" ref={dropdownRef}>
                      {/* Dropdown Button */}
                      <div
                        className="border border-[#9C9C9C] dark:border-[#1F1F1F] dark:bg-primary rounded-xl flex gap-2 items-center px-3 py-1 cursor-pointer relative"
                        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                      >
                        <p className="text-[#9C9C9C] dark:text-[#ffffff] font-poppins">{selectedValue}</p>
                        <button>
                          <img src={Arrow} className="w-4 h-4" />
                        </button>
                      </div>

                      {/* Dropdown Menu - Positioned Above */}
                      {isDropdownOpen && (
                        <div className="absolute left-0 z-50 mb-2 bg-white border dark:border-[#1F1F1F] border-gray-300 rounded-lg shadow-lg dark:bg-primary bottom-full w-max">
                          {options.map((option) => (
                            <p
                              key={option}
                              className="px-4 py-2 text-sm cursor-pointer dark:text-darkText hover:bg-gray-100 dark:hover:bg-slate-700"
                              onClick={() => handleSelect(option)}
                            >
                              {option}
                            </p>
                          ))}
                        </div>
                      )}

                      {/* Results Text */}
                      <p className="text-[#484848] font-poppins text-sm dark:text-gray-600">
                        Showing <span className="font-semibold text-[#000000] text-sm dark:text-darkText ">{pagination?.total}</span> results
                      </p>
                    </div>

                    {/* Pagination Buttons */}
                    <div className="flex items-center">
                      {/* Previous Button */}
                      <button
                        className={`text-[#000000] dark:text-darkText text-sm font-poppins px-3 py-1 rounded-full transition-all duration-200 
      ${pagination?.prev_page === 0 ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-200"}`}
                        onClick={() => setActivePage(prev => (prev > 1 ? prev - 1 : prev))}
                        disabled={pagination?.prev_page === 0}
                      >
                        Previous
                      </button>

                      {/* Page Numbers */}
                      {[...Array(lastPage)].map((_, index) => {
                        const page = index + 1;
                        return (
                          <button
                            key={page}
                            className={`text-sm font-poppins px-3 py-1 rounded-full transition-all duration-200 
          ${activePage === page ? "text-white bg-button-gradient" : "text-black dark:text-darkText hover:bg-gray-200"}`}
                            onClick={() => setActivePage(page)}
                          >
                            {page}
                          </button>
                        );
                      })}

                      {/* Next Button */}
                      <button
                        className={`text-[#000000] dark:text-darkText text-sm font-poppins px-3 py-1 rounded-full transition-all duration-200 
      ${pagination?.next_page > lastPage ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-200"}`}
                        onClick={() => setActivePage(prev => (prev < lastPage ? prev + 1 : prev))}
                        disabled={pagination?.next_page > lastPage}
                      >
                        Next
                      </button>
                    </div>
                  </div>
                </>) : (<></>)}

              </div>
            </div>
          </div>

        </div>
      </div>

      <DeleteReel open={open} handleClose={handleClose} handleDelete={handleDelete} ReelId={selectedPostId} />
      {selectedPostId && (
        <ReelDetail open={openDetail} postId={selectedPostId} handleClose={handleReelDetailClose} />
      )}
    </>
  );
}

export default ReelList;

